export const relativeRect = (fromNode: HTMLElement, toNode: HTMLElement) => {
  const fromRect = fromNode.getBoundingClientRect()
  const toRect = toNode.getBoundingClientRect()
  return {
    left: fromRect.left - toRect.left,
    right: fromRect.right - toRect.left,
    bottom: fromRect.bottom - toRect.top,
    top: fromRect.top - toRect.top,
    width: fromRect.width,
    height: fromRect.height,
  }
}
